import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Loader from "../Loader";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "80%",
    sm: 400,
  },
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const SmartTrade = () => {
  const [tradeLoading, setTradeLoading] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const path = usercalls();
  const [openTrade, setOpenTrade] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [smartTrades, setSmartTrades] = useState([]);
  const [pairs, setPairs] = useState([]);
  const [pairsLoading, setPairsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openFundsModal, setOpenFundsModal] = useState(false);
  const [selectedTradeId, setSelectedTradeId] = useState(null);
  const [fundsLoading, setFundsLoading] = useState(false);
  const [reduceInfo, setReduceInfo] = useState(null);
  const [fundsFormData, setFundsFormData] = useState({
    type: "add",
    order_type: "market",
    units: "",
    price: "",
  });
  const [actionLoading, setActionLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState({
    action: null,
    tradeId: null,
    message: null,
  });
  const [openTradesModal, setOpenTradesModal] = useState(false);
  const [selectedSmartTradeId, setSelectedSmartTradeId] = useState(null);
  const [smartTradeTrades, setSmartTradeTrades] = useState([]);
  const [tradesLoading, setTradesLoading] = useState(false);
  const [tradeActionLoading, setTradeActionLoading] = useState(false);
  const [showTradeConfirmModal, setShowTradeConfirmModal] = useState(false);
  const [confirmTradeAction, setConfirmTradeAction] = useState({
    action: null,
    smartTradeId: null,
    tradeId: null,
    message: null,
  });

  const [formData, setFormData] = useState({
    pair: "",
    leverage_enabled: "false",
    leverage_type: "cross",
    leverage_value: "",
    position_type: "buy",
    position_order_type: "limit",
    position_units: "",
    position_price: "",
    conditional_enabled: "false",
    conditional_order_type: "market",
    conditional_price: "",
    conditional_trailing_enabled: "false",
    conditional_trailing_percent: "",
    take_profit_enabled: "false",
    take_profit_volume: "",
    take_profit_price: "",
    take_profit_trailing_enabled: "false",
    take_profit_trailing_percent: "",
    stop_loss_enabled: "false",
    stop_loss_order_type: "market",
    stop_loss_price: "",
    stop_loss_trailing_enabled: "false",
    stop_loss_trailing_percent: "",
    note: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const getPairs = async () => {
    try {
      setPairsLoading(true);
      const url = `${consts.BackendUrl}/bots/get-trading-pairs`;
      const payload = {
        market: state?.market_code || state?.market,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success || Array.isArray(result)) {
        setPairs(Array.isArray(result) ? result : result?.result || []);
      } else {
        setPairs([]);
      }
      setPairsLoading(false);
    } catch (err) {
      setPairs([]);
      setPairsLoading(false);
    }
  };

  const validateForm = () => {
    if (!state?.id) {
      toast.error("Exchange ID is required");
      return false;
    }
    if (!formData.pair || formData.pair.trim().length === 0) {
      toast.error("Trading pair is required");
      return false;
    }
    if (formData.leverage_enabled === "true" && !formData.leverage_value) {
      toast.error("Leverage value is required when leverage is enabled");
      return false;
    }
    if (
      (formData.position_order_type === "limit" ||
        formData.position_order_type === "market") &&
      !formData.position_price
    ) {
      toast.error("Position price is required");
      return false;
    }
    if (!formData.position_units) {
      toast.error("Position units/quantity is required");
      return false;
    }
    if (
      formData.conditional_enabled === "true" &&
      !formData.conditional_price
    ) {
      toast.error("Conditional price is required");
      return false;
    }
    if (
      formData.take_profit_enabled === "true" &&
      !formData.take_profit_price
    ) {
      toast.error("Take profit price is required");
      return false;
    }
    if (formData.stop_loss_enabled === "true" && !formData.stop_loss_price) {
      toast.error("Stop loss price is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setSubmitLoading(true);
    try {
      const payload = {
        exchange_id: state?.id,
        account_id: state?.account_id,
        pair: formData.pair,
        instant: true,
        skip_enter_step: false,
      };

      if (formData.position_units) {
        payload.position = {
          units: { value: formData.position_units },
        };
        if (
          formData.position_order_type === "limit" &&
          formData.position_price
        ) {
          payload.position.price = { value: formData.position_price };
        }
      }

      if (formData.leverage_enabled === "true") {
        payload.leverage = {
          enabled: true,
          type: formData.leverage_type,
          value: formData.leverage_value,
        };
      }

      if (formData.conditional_enabled === "true") {
        payload.conditional = {
          enabled: true,
          order_type: formData.conditional_order_type,
          price: { value: formData.conditional_price },
        };
        if (formData.conditional_trailing_enabled === "true") {
          payload.conditional.trailing = {
            enabled: true,
            percent: formData.conditional_trailing_percent,
          };
        }
      }

      if (formData.take_profit_enabled === "true") {
        payload.take_profit = {
          enabled: true,
          steps: [
            {
              order_type: "market",
              volume: formData.take_profit_volume || 100,
              price: { value: formData.take_profit_price },
            },
          ],
        };
        if (formData.take_profit_trailing_enabled === "true") {
          payload.take_profit.steps[0].trailing = {
            enabled: true,
            percent: formData.take_profit_trailing_percent,
          };
        }
      }

      if (formData.stop_loss_enabled === "true") {
        payload.stop_loss = {
          enabled: true,
          order_type: formData.stop_loss_order_type,
          price: { value: formData.stop_loss_price },
        };
        if (formData.stop_loss_trailing_enabled === "true") {
          payload.stop_loss.trailing = {
            enabled: true,
            percent: formData.stop_loss_trailing_percent,
          };
        }
      }

      if (formData.note) {
        payload.note = formData.note;
      }

      const url = `${consts.BackendUrl}/bots/create-smart-trade`;
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Smart Trade created successfully");
        setOpenTrade(false);
        resetForm();
        await getSmartTrades();
      } else {
        toast.error(result?.message || "Failed to create Smart Trade");
      }
    } catch (err) {
      toast.error("Failed to create Smart Trade");
    } finally {
      setSubmitLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      pair: "",
      leverage_enabled: "false",
      leverage_type: "cross",
      leverage_value: "",
      position_type: "buy",
      position_order_type: "limit",
      position_units: "",
      position_price: "",
      conditional_enabled: "false",
      conditional_order_type: "market",
      conditional_price: "",
      conditional_trailing_enabled: "false",
      conditional_trailing_percent: "",
      take_profit_enabled: "false",
      take_profit_volume: "",
      take_profit_price: "",
      take_profit_trailing_enabled: "false",
      take_profit_trailing_percent: "",
      stop_loss_enabled: "false",
      stop_loss_order_type: "market",
      stop_loss_price: "",
      stop_loss_trailing_enabled: "false",
      stop_loss_trailing_percent: "",
      note: "",
    });
    setEditIndex(null);
  };

  const handleOpenTrade = () => {
    resetForm();
    setOpenTrade(true);
  };

  const handleCloseTrade = () => {
    setOpenTrade(false);
    resetForm();
  };

  const getSmartTrades = async (status = null) => {
    if (!state?.id) return;

    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-smart-trade`;
      const payload = {
        exchange_id: state.id,
        per_page: 100,
      };

      if (status) {
        payload.status = status;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const trades = Array.isArray(result.result) ? result.result : [];
        setSmartTrades(trades);
      } else {
        setSmartTrades([]);
      }
    } catch (err) {
      setSmartTrades([]);
    } finally {
      setTradeLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (!state?.market_code && !state?.market) return;
    getPairs();
  }, [state?.market_code, state?.market]);

  useEffect(() => {
    if (state?.id) {
      getSmartTrades();
    }
  }, [state?.id]);

  const isHistoryStatus = (basicType) =>
    basicType === "finished" ||
    basicType === "failed" ||
    basicType === "cancelled";

  const activeTrades = smartTrades.filter(
    (trade) => !isHistoryStatus(trade.status?.basic_type),
  );

  const tradeHistory = smartTrades.filter((trade) =>
    isHistoryStatus(trade.status?.basic_type),
  );

  const activePaginated = activeTrades.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const historyPaginated = tradeHistory.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const formatDate = (dateString) => {
    if (!dateString) return "---";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const getValue = (value, fallback = "---") => {
    if (value == null) return fallback;
    if (typeof value === "object" && "value" in value) return value.value;
    return value;
  };

  const handleOpenFundsModal = async (tradeId) => {
    setSelectedTradeId(tradeId);
    setOpenFundsModal(true);
    await getSmartTradeReduceInfo(tradeId);
  };

  const handleCloseFundsModal = () => {
    setOpenFundsModal(false);
    setSelectedTradeId(null);
    setReduceInfo(null);
    setFundsFormData({
      type: "add",
      order_type: "market",
      units: "",
      price: "",
    });
  };

  const getSmartTradeReduceInfo = async (tradeId) => {
    try {
      setFundsLoading(true);
      const url = `${consts.BackendUrl}/bots/smart-trade-reduce-info`;
      const payload = { id: tradeId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setReduceInfo(result.result);
      } else {
      }
    } catch (err) {
    } finally {
      setFundsLoading(false);
    }
  };

  const handleManageSmartTradeFunds = async () => {
    try {
      if (
        !selectedTradeId ||
        !fundsFormData.units ||
        !fundsFormData.order_type
      ) {
        toast.error("Please fill in all required fields");
        return;
      }

      if (
        fundsFormData.order_type === "limit" &&
        (!fundsFormData.price || fundsFormData.price <= 0)
      ) {
        toast.error("Price is required for limit orders");
        return;
      }

      setFundsLoading(true);
      const url = `${consts.BackendUrl}/bots/smart-trade-funds`;
      const payload = {
        id: selectedTradeId,
        type: fundsFormData.type,
        order_type: fundsFormData.order_type,
        units: fundsFormData.units,
      };

      if (fundsFormData.price) {
        payload.price = fundsFormData.price;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        handleCloseFundsModal();
        await getSmartTrades();
      } else {
      }
    } catch (err) {
    } finally {
      setFundsLoading(false);
    }
  };

  const openConfirmModal = (actionType, tradeId, message) => {
    setConfirmAction({
      action: actionType,
      tradeId,
      message,
    });
    setShowConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setConfirmAction({
      action: null,
      tradeId: null,
      message: null,
    });
  };

  const executeConfirmedAction = async () => {
    try {
      setActionLoading(true);
      const { action, tradeId } = confirmAction;
      let url;
      let payload = { smart_trade_id: tradeId };

      if (action === "cancel") {
        url = `${consts.BackendUrl}/bots/cancel-smart-trade`;
      } else if (action === "close") {
        url = `${consts.BackendUrl}/bots/close-smart-trade-at-market`;
      } else if (action === "force-start") {
        url = `${consts.BackendUrl}/bots/force-start-smart-trade`;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Action executed successfully");
        closeConfirmModal();
        await getSmartTrades();
      } else {
        toast.error(result?.message || "Failed to execute action");
      }
    } catch (err) {
      toast.error("An error occurred while executing the action");
    } finally {
      setActionLoading(false);
    }
  };

  const handleOpenTradesModal = async (tradeId) => {
    setSelectedSmartTradeId(tradeId);
    setOpenTradesModal(true);
    await getSmartTradeTradesData(tradeId);
  };

  const handleCloseTradesModal = () => {
    setOpenTradesModal(false);
    setSelectedSmartTradeId(null);
    setSmartTradeTrades([]);
  };

  const getSmartTradeTradesData = async (tradeId) => {
    try {
      setTradesLoading(true);
      const url = `${consts.BackendUrl}/bots/get-smart-trade-trades`;
      const payload = { smart_trade_id: tradeId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const trades = Array.isArray(result.result) ? result.result : [];
        setSmartTradeTrades(trades);
      } else {
        setSmartTradeTrades([]);
      }
    } finally {
      setTradesLoading(false);
    }
  };

  const openTradeConfirmModal = (
    actionType,
    smartTradeId,
    tradeId,
    message,
  ) => {
    setConfirmTradeAction({
      action: actionType,
      smartTradeId,
      tradeId,
      message,
    });
    setShowTradeConfirmModal(true);
  };

  const closeTradeConfirmModal = () => {
    setShowTradeConfirmModal(false);
    setConfirmTradeAction({
      action: null,
      smartTradeId: null,
      tradeId: null,
      message: null,
    });
  };

  const executeTradeAction = async () => {
    try {
      setTradeActionLoading(true);
      const { action, smartTradeId, tradeId } = confirmTradeAction;
      let url;
      let payload = { smart_trade_id: smartTradeId, trade_id: tradeId };

      if (action === "close") {
        url = `${consts.BackendUrl}/bots/close-smart-trade-trade-at-market`;
      } else if (action === "cancel") {
        url = `${consts.BackendUrl}/bots/cancel-smart-trade-trade`;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const actionMessages = {
          close: "Trade closed at market price successfully",
          cancel: "Trade cancelled successfully",
        };
        if (action !== "cancel") {
          toast.success(result?.message || actionMessages[action]);
        }
        closeTradeConfirmModal();
        await getSmartTradeTradesData(smartTradeId);
      } else {
      }
    } finally {
      setTradeActionLoading(false);
    }
  };

  // Check if state is undefined and navigate back
  useEffect(() => {
    if (!state?.id) {
      navigate("/bot");
    }
  }, [state, navigate]);

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="bot_dash contain-width ">
            <div className="display-2">
              <h3 className="">Smart Trade</h3>
              <div className="bot_comman_btn">
                <Button onClick={handleOpenTrade}>Create Trade</Button>
              </div>
            </div>
          </div>
          <div className="mt-20">
            <div className="custom_table box_bdr mt-20">
              <div className="h_flx">
                <h3>Smart Trade</h3>
              </div>

              <TableContainer sx={{ marginBottom: "10px" }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Created At</TableCell>
                      <TableCell>Pair</TableCell>
                      <TableCell>Position Type</TableCell>
                      <TableCell>Order Type</TableCell>
                      <TableCell>Units</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Total</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Profit (%)</TableCell>
                      <TableCell>Trade ID</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {tradeLoading ? (
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div className="inline-loader">
                            <Loader />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : smartTrades?.length > 0 ? (
                      smartTrades
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((row, i) => {
                          const isFailed =
                            row.status?.basic_type === "failed" ||
                            row.status?.type === "failed";

                          return (
                            <TableRow key={i} className="tr_row">
                              <TableCell>
                                {formatDate(row.data?.created_at)}
                              </TableCell>
                              <TableCell>{row.pair}</TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.position?.type === "long"
                                      ? "#00C853"
                                      : "#FF5252",
                                }}
                              >
                                {row.position?.type?.toUpperCase()}
                              </TableCell>
                              <TableCell>{row.position?.order_type}</TableCell>
                              <TableCell>
                                {getValue(row.position?.units)}
                              </TableCell>
                              <TableCell>
                                {getValue(row.position?.price)}
                              </TableCell>
                              <TableCell>
                                {getValue(row.position?.total)}
                              </TableCell>
                              <TableCell>
                                <span
                                  style={{
                                    color:
                                      row.status?.basic_type === "success"
                                        ? "#00C853"
                                        : "#FF5252",
                                  }}
                                >
                                  {row.status?.title}
                                </span>
                              </TableCell>
                              <TableCell
                                style={{
                                  color:
                                    Number(row.profit?.percent) >= 0
                                      ? "#00C853"
                                      : "#FF5252",
                                }}
                              >
                                {row.profit?.percent != null
                                  ? `${Number(row.profit?.percent).toFixed(2)}%`
                                  : "0.00%"}
                              </TableCell>
                              <TableCell>{row.id}</TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "4px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() =>
                                      handleOpenTradesModal(row.id)
                                    }
                                    sx={{
                                      fontSize: "0.7rem",
                                      padding: "4px 8px",
                                    }}
                                  >
                                    View
                                  </Button>
                                  {!isFailed && (
                                    <>
                                      <Button
                                        size="small"
                                        variant="contained"
                                        onClick={() =>
                                          handleOpenFundsModal(row.id)
                                        }
                                        sx={{
                                          fontSize: "0.7rem",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        Funds
                                      </Button>
                                      <Button
                                        size="small"
                                        variant="contained"
                                        color="info"
                                        onClick={() =>
                                          openConfirmModal(
                                            "force-start",
                                            row.id,
                                            "Force start this trade at market price?",
                                          )
                                        }
                                        sx={{
                                          fontSize: "0.7rem",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        Force Start
                                      </Button>
                                      <Button
                                        size="small"
                                        variant="contained"
                                        color="warning"
                                        onClick={() =>
                                          openConfirmModal(
                                            "close",
                                            row.id,
                                            "Close this trade at market price?",
                                          )
                                        }
                                        sx={{
                                          fontSize: "0.7rem",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        Close
                                      </Button>
                                      <Button
                                        size="small"
                                        variant="contained"
                                        color="error"
                                        onClick={() =>
                                          openConfirmModal(
                                            "cancel",
                                            row.id,
                                            "Cancel this trade? This action cannot be undone.",
                                          )
                                        }
                                        sx={{
                                          fontSize: "0.7rem",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        Cancel
                                      </Button>
                                    </>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={11} align="center">
                          No Trades Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={smartTrades.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </div>
        </Grid>
      </Grid>

      <Modal
        open={openTrade}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">
              {editIndex !== null ? "Edit Smart Trade" : "Create Smart Trade"}
            </div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseTrade}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            className=""
            style={{ maxHeight: "500px", overflow: "auto" }}
          >
            {pairs && pairs.length > 0 ? (
              <FormControl fullWidth required>
                <InputLabel id="pair-label">Pair</InputLabel>
                <Select
                  className="bot-select"
                  fullWidth
                  name="pair"
                  value={formData.pair}
                  onChange={handleChange}
                  labelId="pair-label"
                  id="pair"
                  label="Pair"
                  disabled={pairsLoading}
                  required
                >
                  <MenuItem value="">Select Pair</MenuItem>
                  {pairs.map((p, idx) => {
                    const label =
                      typeof p === "string"
                        ? p
                        : p.pair || p.symbol || p.name || p.label;
                    const value =
                      typeof p === "string"
                        ? p
                        : p.pair || p.symbol || p.name || p.value;
                    return (
                      <MenuItem key={idx} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : (
              <TextField
                label="Pair"
                name="pair"
                fullWidth
                className="bot-input"
                value={formData.pair}
                onChange={handleChange}
                required
              />
            )}

            <TextField
              label="Position Units (Quantity) (required)"
              name="position_units"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.position_units}
              onChange={handleChange}
              required
              inputProps={{ step: "0.00000001" }}
            />

            <FormControl fullWidth>
              <InputLabel>Position Order Type</InputLabel>
              <Select
                className="bot-select"
                name="position_order_type"
                value={formData.position_order_type}
                onChange={handleChange}
                label="Position Order Type"
              >
                <MenuItem value="market">Market</MenuItem>
                <MenuItem value="limit">Limit</MenuItem>
              </Select>
            </FormControl>

            {(formData.position_order_type === "limit" ||
              formData.position_order_type === "market") && (
              <TextField
                label="Position Price (required)"
                name="position_price"
                type="number"
                fullWidth
                className="bot-input"
                value={formData.position_price}
                onChange={handleChange}
                required={
                  formData.position_order_type === "limit" ||
                  formData.position_order_type === "market"
                }
                inputProps={{ step: "0.00000001" }}
              />
            )}

            <FormControl fullWidth>
              <InputLabel>Leverage (optional)</InputLabel>
              <Select
                className="bot-select"
                name="leverage_enabled"
                value={formData.leverage_enabled}
                onChange={handleChange}
                label="Leverage (optional)"
              >
                <MenuItem value="false">Disable Leverage</MenuItem>
                <MenuItem value="true">Enable Leverage</MenuItem>
              </Select>
            </FormControl>

            {formData.leverage_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Leverage Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="leverage_type"
                    value={formData.leverage_type}
                    onChange={handleChange}
                    label="Leverage Type"
                  >
                    <MenuItem value="cross">Cross</MenuItem>
                    <MenuItem value="isolated">Isolated</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Leverage Value"
                  name="leverage_value"
                  type="number"
                  fullWidth
                  className="bot-input"
                  value={formData.leverage_value}
                  onChange={handleChange}
                  inputProps={{ min: "1", max: "125" }}
                />
              </>
            )}

            <FormControl fullWidth>
              <InputLabel>Conditional Order (optional)</InputLabel>
              <Select
                className="bot-select"
                name="conditional_enabled"
                value={formData.conditional_enabled}
                onChange={handleChange}
                label="Conditional Order (optional)"
              >
                <MenuItem value="false">Disabled</MenuItem>
                <MenuItem value="true">Enabled</MenuItem>
              </Select>
            </FormControl>

            {formData.conditional_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Conditional Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="conditional_order_type"
                    value={formData.conditional_order_type}
                    onChange={handleChange}
                    label="Conditional Order Type"
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Conditional Price"
                  name="conditional_price"
                  type="number"
                  fullWidth
                  className="bot-input"
                  value={formData.conditional_price}
                  onChange={handleChange}
                  inputProps={{ step: "0.00000001" }}
                />
              </>
            )}

            <FormControl fullWidth>
              <InputLabel>Take Profit (optional)</InputLabel>
              <Select
                className="bot-select"
                name="take_profit_enabled"
                value={formData.take_profit_enabled}
                onChange={handleChange}
                label="Take Profit (optional)"
              >
                <MenuItem value="false">Disabled</MenuItem>
                <MenuItem value="true">Enabled</MenuItem>
              </Select>
            </FormControl>

            {formData.take_profit_enabled === "true" && (
              <>
                <TextField
                  label="Take Profit Price"
                  name="take_profit_price"
                  type="number"
                  fullWidth
                  className="bot-input"
                  value={formData.take_profit_price}
                  onChange={handleChange}
                  inputProps={{ step: "0.00000001" }}
                />
                <TextField
                  label="Volume (%)"
                  name="take_profit_volume"
                  type="number"
                  fullWidth
                  className="bot-input"
                  value={formData.take_profit_volume}
                  onChange={handleChange}
                  inputProps={{ min: "0", max: "100", step: "1" }}
                />
              </>
            )}

            <FormControl fullWidth>
              <InputLabel>Stop Loss (optional)</InputLabel>
              <Select
                className="bot-select"
                name="stop_loss_enabled"
                value={formData.stop_loss_enabled}
                onChange={handleChange}
                label="Stop Loss (optional)"
              >
                <MenuItem value="false">Disabled</MenuItem>
                <MenuItem value="true">Enabled</MenuItem>
              </Select>
            </FormControl>

            {formData.stop_loss_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Stop Loss Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="stop_loss_order_type"
                    value={formData.stop_loss_order_type}
                    onChange={handleChange}
                    label="Stop Loss Order Type"
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Stop Loss Price"
                  name="stop_loss_price"
                  type="number"
                  fullWidth
                  className="bot-input"
                  value={formData.stop_loss_price}
                  onChange={handleChange}
                  inputProps={{ step: "0.00000001" }}
                />
              </>
            )}

            <TextField
              label="Note (optional)"
              name="note"
              fullWidth
              multiline
              rows={2}
              className="bot-input"
              value={formData.note}
              onChange={handleChange}
            />
          </Box>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openFundsModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Manage Smart Trade Funds</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseFundsModal}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            style={{ maxHeight: "400px", overflow: "auto" }}
          >
            {fundsLoading ? (
              <div className="inline-loader">
                <Loader />
              </div>
            ) : (
              <>
                <FormControl fullWidth>
                  <InputLabel id="funds-type-label">Type</InputLabel>
                  <Select
                    className="bot-select"
                    labelId="funds-type-label"
                    id="funds-type"
                    value={fundsFormData.type}
                    label="Type"
                    onChange={(e) =>
                      setFundsFormData({
                        ...fundsFormData,
                        type: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="add">Add Funds</MenuItem>
                    <MenuItem value="reduce">Reduce Funds</MenuItem>
                  </Select>
                </FormControl>

                {fundsFormData.type === "reduce" && reduceInfo && (
                  <Box
                    sx={{
                      backgroundColor: "rgba(86, 111, 255, 0.1)",
                      padding: "12px",
                      borderRadius: "8px",
                    }}
                  >
                    <p style={{ margin: "0 0 8px 0", fontSize: "0.9rem" }}>
                      <strong>Available to Reduce:</strong>{" "}
                      {reduceInfo?.available}
                    </p>
                    {reduceInfo?.required && (
                      <p style={{ margin: "0", fontSize: "0.9rem" }}>
                        <strong>Required to Keep:</strong>{" "}
                        {reduceInfo?.required}
                      </p>
                    )}
                  </Box>
                )}

                <FormControl fullWidth>
                  <InputLabel id="order-type-label">Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    labelId="order-type-label"
                    id="order-type"
                    value={fundsFormData.order_type}
                    label="Order Type"
                    onChange={(e) =>
                      setFundsFormData({
                        ...fundsFormData,
                        order_type: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Units"
                  type="number"
                  value={fundsFormData.units}
                  onChange={(e) =>
                    setFundsFormData({
                      ...fundsFormData,
                      units: e.target.value,
                    })
                  }
                  inputProps={{ step: "any" }}
                />

                {fundsFormData.order_type === "limit" && (
                  <TextField
                    fullWidth
                    label="Price"
                    type="number"
                    value={fundsFormData.price}
                    onChange={(e) =>
                      setFundsFormData({
                        ...fundsFormData,
                        price: e.target.value,
                      })
                    }
                    inputProps={{ step: "any" }}
                  />
                )}
              </>
            )}
          </Box>

          <div className="modal-footer mt-20">
            <Button
              variant="contained"
              onClick={handleCloseFundsModal}
              disabled={fundsLoading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleManageSmartTradeFunds}
              disabled={fundsLoading}
            >
              {fundsLoading
                ? "Processing..."
                : `${fundsFormData.type === "add" ? "Add" : "Reduce"} Funds`}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={showConfirmModal}
        aria-labelledby="confirm-modal-title"
        aria-describedby="confirm-modal-description"
      >
        <Box sx={style}>
          <div className="p-20">
            {confirmAction.message || "Are you sure you want to proceed?"}
          </div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={closeConfirmModal}
                disabled={actionLoading}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color={
                  confirmAction.action === "cancel"
                    ? "error"
                    : confirmAction.action === "close"
                      ? "warning"
                      : "info"
                }
                onClick={executeConfirmedAction}
                disabled={actionLoading}
              >
                {actionLoading ? "Processing..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openTradesModal}
        aria-labelledby="trades-modal-title"
        aria-describedby="trades-modal-description"
      >
        <Box sx={{ ...style, width: 900, maxHeight: "90vh", overflow: "auto" }}>
          <div className="display-2 p-20">
            <div className="coins">Smart Trade Trades</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseTradesModal}
            />
          </div>

          <Box sx={{ padding: "20px" }}>
            {tradesLoading ? (
              <div className="inline-loader">
                <Loader />
              </div>
            ) : smartTradeTrades.length > 0 ? (
              <TableContainer
                sx={{
                  maxHeight: "320px",
                  overflow: "auto",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.18)",
                  backgroundColor: "rgba(8,12,18,0.92)",
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                  color: "#FFFFFF",
                }}
              >
                <Table
                  size="small"
                  stickyHeader
                  sx={{
                    "& .MuiTableCell-root": {
                      color: "#FFFFFF",
                      borderColor: "rgba(255,255,255,0.12)",
                    },
                    "& .MuiTableHead-root .MuiTableCell-root": {
                      backgroundColor: "#10151C",
                      fontWeight: 700,
                    },
                    "& .MuiTableBody-root .MuiTableRow-root": {
                      backgroundColor: "rgba(10,14,20,0.88)",
                    },
                    "& .MuiTableBody-root .MuiTableRow-root:hover": {
                      backgroundColor: "rgba(18,24,32,0.95)",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow sx={{}}>
                      <TableCell>Trade ID</TableCell>
                      <TableCell>Pair</TableCell>
                      <TableCell>Side</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Initial Amount</TableCell>
                      <TableCell>Initial Total</TableCell>
                      <TableCell>Realised Amount</TableCell>
                      <TableCell>Realised Total</TableCell>
                      <TableCell>Realised %</TableCell>
                      <TableCell>Created At</TableCell>
                      <TableCell>Updated At</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {smartTradeTrades.map((trade, i) => (
                      <TableRow key={i} className="tr_row">
                        <TableCell>{trade.id}</TableCell>
                        <TableCell>{trade.pair}</TableCell>
                        <TableCell
                          style={{
                            color:
                              trade.order_side === "buy"
                                ? "#00C853"
                                : "#FF5252",
                          }}
                        >
                          {trade.order_side?.toUpperCase()}
                        </TableCell>
                        <TableCell>{trade.order_type}</TableCell>
                        <TableCell
                          style={{
                            color:
                              trade.status === "finished"
                                ? "#00C853"
                                : trade.status === "cancelled"
                                  ? "#FF5252"
                                  : "#FFA500",
                          }}
                        >
                          {trade.status}
                        </TableCell>
                        <TableCell>{trade.initial_amount}</TableCell>
                        <TableCell>{trade.initial_total}</TableCell>
                        <TableCell>{trade.realised_amount}</TableCell>
                        <TableCell>{trade.realised_total}</TableCell>
                        <TableCell
                          style={{
                            color:
                              parseFloat(trade.realised_percentage) > 0
                                ? "#00C853"
                                : "#FF5252",
                          }}
                        >
                          {trade.realised_percentage}
                        </TableCell>
                        <TableCell>{formatDate(trade.created_at)}</TableCell>
                        <TableCell>{formatDate(trade.updated_at)}</TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              flexWrap: "wrap",
                            }}
                          >
                            {trade.status !== "finished" &&
                              trade.status !== "cancelled" &&
                              trade.status !== "failed" && (
                                <>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="warning"
                                    onClick={() =>
                                      openTradeConfirmModal(
                                        "close",
                                        selectedSmartTradeId,
                                        trade.id,
                                        "Close this trade at market price?",
                                      )
                                    }
                                    sx={{
                                      fontSize: "0.65rem",
                                      padding: "3px 6px",
                                    }}
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="error"
                                    onClick={() =>
                                      openTradeConfirmModal(
                                        "cancel",
                                        selectedSmartTradeId,
                                        trade.id,
                                        "Cancel this trade?",
                                      )
                                    }
                                    sx={{
                                      fontSize: "0.65rem",
                                      padding: "3px 6px",
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </>
                              )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p style={{ textAlign: "center", padding: "20px" }}>
                No trades found for this Smart Trade
              </p>
            )}
          </Box>

          <div className="modal-footer mt-20">
            <Button
              variant="contained"
              onClick={handleCloseTradesModal}
              disabled={tradesLoading}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={showTradeConfirmModal}
        aria-labelledby="trade-confirm-modal-title"
        aria-describedby="trade-confirm-modal-description"
      >
        <Box sx={style}>
          <div className="p-20">
            {confirmTradeAction.message || "Are you sure you want to proceed?"}
          </div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={closeTradeConfirmModal}
                disabled={tradeActionLoading}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color={
                  confirmTradeAction.action === "cancel" ? "error" : "warning"
                }
                onClick={executeTradeAction}
                disabled={tradeActionLoading}
              >
                {tradeActionLoading ? "Processing..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default SmartTrade;
